class TimeUtil {
  static sleep(duration) {
    return new Promise((resolve) => {
      setTimeout(resolve, duration);
    });
  }
}

export default TimeUtil;
